import styled, { withTheme } from 'styled-components';
import bp from '@bootstrap-styled/css-mixins/lib/breakpoints';

const RadioContainer = styled.div.attrs(() => (
    {
        className: 'radio-container',
    }
))`
    padding:10px 16px;
    label {
        padding:0;
        margin:0;
        &.pair-label {
            ${props => bp.down('sm', props.theme['$grid-breakpoints'], `
            margin:0 0 10px 0;
        `)}

        }
    }
    .radio-body {
        text-align:right;
        ${props => bp.down('sm', props.theme['$grid-breakpoints'], `
            text-align:left;
        `)}
    }

`;

export default withTheme(RadioContainer);
